import { createRequest } from "src/base/http/axios";
import { METHOD } from "src/config";

const API = {
  read: (payload = {}) => {
    return createRequest({
      method: METHOD.GET,
      endpoint: "/orders",
      payload,
    });
  },
  get: (payload) => {
    if (!payload.hasOwnProperty("id")) {
      return null;
    }

    let endpoint = "/order/" + payload.id;

    return createRequest({
      method: METHOD.GET,
      endpoint,
      payload,
    });
  },
  readCart: (payload = {}) => {
    return createRequest({
      method: METHOD.GET,
      endpoint: "/carts",
      payload,
      crossDomain: true,
      headers: {
        "X-Request-With-Khanhnc": "enable_session",
      },
    });
  },
  readAddress: (payload = {}) => {
    return createRequest({
      method: METHOD.GET,
      endpoint: "/addresses",
      payload: payload,
    });
  },
  checkout: (payload = {}) => {
    return createRequest({
      method: METHOD.POST,
      endpoint: "/orders/checkout",
      payload,
      crossDomain: true,
      headers: {
        "X-Request-With-Khanhnc": "enable_session",
      },
    });
  },
};

export default API;
